/* istanbul ignore file */
import features from './featuresList';

export default features;
